import { Link } from "react-router-dom";
import { ArrowLeft, Download } from "lucide-react";

const DOCS = {
  termini: { title: "Termini e Condizioni di Vendita", file: "/legal/termini.pdf" },
  privacy: { title: "Privacy Policy", file: "/legal/privacy.pdf" },
  cookie: { title: "Cookie Policy", file: "https://app.legalblink.it/api/documents/6aa4130737970d0022efad9a/cookie-policy-it", download: "/legal/cookie.pdf" },
};

export default function LegalPage({ doc }) {
  const d = DOCS[doc];
  return (
    <div className="safe-pt flex min-h-screen flex-col bg-cream">
      <div className="mx-auto flex w-full max-w-5xl items-center justify-between px-6 py-6 md:px-10">
        <div className="flex items-center gap-3">
          <Link to="/" data-testid="legal-back" aria-label="Torna al negozio" className="grid h-9 w-9 place-items-center rounded-full border border-ink/15 text-ink hover:bg-ink hover:text-cream">
            <ArrowLeft className="h-4 w-4" strokeWidth={1.8} />
          </Link>
          <Link to="/" className="notranslate font-serif text-3xl text-ink" translate="no">NEED</Link>
        </div>
        <a href={d.download || d.file} download data-testid="legal-download" className="flex items-center gap-2 rounded-full border border-ink/15 px-4 py-2 text-sm text-ink hover:bg-ink hover:text-cream">
          <Download className="h-4 w-4" /> Scarica PDF
        </a>
      </div>
      <h1 className="mx-auto w-full max-w-5xl px-6 pb-4 font-serif text-3xl text-ink md:px-10" data-testid="legal-title">{d.title}</h1>
      <div className="mx-auto w-full max-w-5xl px-6 md:px-10">
        <a href={d.file} target="_blank" rel="noreferrer" data-testid="legal-open-full" className="text-xs text-ink-soft underline decoration-sage/50 underline-offset-2 hover:text-ink">
          Non vedi il documento? Aprilo a tutto schermo
        </a>
      </div>
      <div className="mx-auto mb-10 w-full max-w-5xl flex-1 px-6 md:px-10">
        <iframe
          src={d.file}
          title={d.title}
          data-testid="legal-frame"
          className="h-[70vh] w-full rounded-2xl border border-ink/10 bg-white"
        />
      </div>
    </div>
  );
}
